import styled from 'styled-components';
import {
  flexbox,
  alignItems,
  flexDirection,
  justifyContent
} from '../../styles/helpers/flexbox';

const Wrapper = styled.span((props) => {
  const { colours } = props.theme;

  return `
    ${flexbox()};
    ${flexDirection('column-reverse')};
    ${alignItems('center')};

    background-color: #eaf9f9;
    border-right: 1px solid ${colours.grey[400]};
    height: 100%;
    min-width: 53px;
    max-width: 53px;
    position: relative;
    cursor: pointer;
    overflow: hidden;
`;
});

const Name = styled.div((props) => {
  const { palette } = props.theme;

  return `
    -webkit-transform: rotate(-90deg);
    -moz-transform: rotate(-90deg);
    -ms-transform: rotate(-90deg);
    -o-transform: rotate(-90deg);
    transform: rotate(-90deg);
    transform-origin: (0,0);

    box-sizing: border-box;
    padding-left: 7px;
    padding-right: 5px;
    height: 52px;
    width: 128px;
    margin: 38px 0;
    font-size: 12px;
    color: ${palette.primary.dark};
`;
});

const Icon = styled.span`
  ${flexbox()};
  ${alignItems('center')};

  height: 20px;
  cursor: pointer;
`;

const Help = styled.div`
  ${flexbox()};
  ${alignItems('center')};

  cursor: pointer;
  width: 100%;
  height: 20px;
  text-align: center;

  [class^='svgIconComponent'] {
    width: 23px;
  }

  .iconWrapper {
    ${flexbox()};
    ${justifyContent('center')};

    width: 100%;
  }

  .number {
    position: relative;
    color: red;
    font-weight: 600;
    text-align: center;
    left: -26px;
    top: -2px;
  }
`;

const ContextMenuAction = styled.div((props) => {
  const { colours, palette } = props.theme;
  const blacklistStyle = props.blackListed
    ? `background-color: white !important;
      opacity: 0.2;`
    : ` 
    cursor: pointer;
    &:hover {
      background-color: ${colours.grey[200]} !important;
      color: ${palette.secondary.dark};
  `;
  return `
  ${flexbox()};
  ${alignItems('center')};

  
  width: 100%;
  height: 30px;
  padding-left: 10px;
  color: ${palette.primary.dark};
  border-bottom:  ${!props.last ? `1px solid ${colours.grey[400]};` : 'none'};
  border-top: ${props.first ? `1px solid ${colours.grey[400]};` : 'none'};

  span[class*="isvg"] {
    margin-right: 10px;
  }
  ${blacklistStyle}
`;
});

export { Wrapper, Name, Icon, Help, ContextMenuAction };



// WEBPACK FOOTER //
// ./components/activity-header/styled.js